import AttendApplicationApprovalV3 from './AttendApplicationApprovalV3'

export default AttendApplicationApprovalV3;
